import { HomepageData } from '../types/homepage';
import homepageData from '../data/homepageData.json';

export const useHomepageData = () => {
  const data = homepageData as HomepageData;
  const loading = false;
  const error = null;

  return { data, loading, error };
};
